const setVh = () => document.documentElement.style.setProperty('--vh', window.innerHeight * 0.01 + 'px');

const setViewportHeight = () => {
  setVh();

  window.addEventListener('resize', setVh);
};

export default setViewportHeight;
